import React, { Component } from 'react';
import classNames from 'classnames';
import { IProductMenuDisplay } from 'core/redux/features/products/types';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { locationParser } from 'core/utils/location';

interface IMenuProps extends RouteComponentProps {
  route?: string;
  menuPreviews: IProductMenuDisplay[];
  onClickMenu?: (e: React.MouseEvent, menuKey: number) => void;
}

export class PlainMenuListComp extends Component<IMenuProps> {
  render() {
    const {
      props: { menuPreviews },
    } = this;

    return (
      <div className="is-flex-mid-col">
        {menuPreviews &&
          menuPreviews.map((menu, key) => (
            <div
              onClick={e => this.onClickMenu(e, key)}
              className={classNames(
                'show-menu__item',
                menu.id === 0 && 'more-menu',
              )}
              key={key}
            >
              <div className="eb-ellipsis">{menu.name}</div>
            </div>
          ))}
      </div>
    );
  }

  private onClickMenu = (e: React.MouseEvent, key: number) => {
    if (this.props.onClickMenu) {
      this.props.onClickMenu(e, key);
    }

    if (
      this.props.route &&
      this.props.route !== locationParser(this.props.location).toString()
    ) {
      this.props.history.push(this.props.route);
    }
  };
}

const PlainMenuList = withRouter(PlainMenuListComp);
export default PlainMenuList;
// export default memo(
//   PlainMenuList,
//   ({ menuPreviews: menuPreviewsA }, { menuPreviews: menuPreviewsB }) =>
//     shallowEqual(menuPreviewsA, menuPreviewsB)
// )
